import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { UserSurveyAnswerModel, UserSurveyDto } from '@/models/surveys.models';

export const surveysService = {
  getActiveSurveys,
  addSurveyAnswer
};

let model = {
  controller: 'userSurveys',
  get baseUrl() { return store.getters[_act.SETT_GET_APIURLGET]; },
  get controllerPath(): string { return `${model.baseUrl}${model.controller}`; }
};

async function getActiveSurveys(): Promise<UserSurveyDto[]> {
  let { data } = await axios.get<UserSurveyDto[]>(`${model.controllerPath}`);
  return (data || []).map(d => new UserSurveyDto(d));
}

async function addSurveyAnswer(surveyAnswer: UserSurveyAnswerModel): Promise<boolean> {
  let { data } = await axios.post<boolean>(`${model.controllerPath}`, surveyAnswer);
  return data;
}
